import { ReactElement, useMemo } from 'react';

import {
  EditAudience,
  EditShop,
  ReadOnlyAudience,
  ReadOnlyShop,
} from 'pages/audience/shared/save/components/slideout/components/order-type/components';
import { useIsAudience, useIsExisting, useSaveStoreSelector } from 'pages/audience/shared/save/hooks';

export const useOrderTypeConfiguration = () => {
  const isAudience = useIsAudience();
  const isExisting = useIsExisting();

  const saveTo = useSaveStoreSelector(({ saveTo }) => saveTo);

  const component: ReactElement = useMemo(() => {
    if (isAudience) {
      return isExisting ? <ReadOnlyAudience /> : <EditAudience />;
    }

    return isExisting || saveTo ? <ReadOnlyShop /> : <EditShop />;
  }, [isAudience, isExisting, saveTo]);

  return {
    component,
  };
};
